import React from 'react';
import Navigation from '../../components/common/Navigation';
import { useHistory } from 'react-router-dom';
import HeaderContainer from '../../containers/common/HeaderContainer';
import { SideSpacer } from '../../components/common/Spacer';
import {
  CommonContainer,
  HorizonWrapper,
} from '../../components/common/Container';
import RegistPatMemberContainer from '../../containers/smartstore/RegistPatMemberContainer';

const RegistPatMemberInfoPage = () => {

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
      <HorizonWrapper>
        <CommonContainer>
            <RegistPatMemberContainer />
        </CommonContainer>
      </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default RegistPatMemberInfoPage;

